/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/custom_subdomain" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCustomSubdomain } from "./constants";
import type { GetLandingPagesCustomSubdomainResult } from "./types";

export const getLandingPagesCustomSubdomain = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdCustomSubdomain,
  (signal: AbortSignal, appGroupId: string): Promise<GetLandingPagesCustomSubdomainResult> => {
    return fetch(`/engagement/landing_pages/${appGroupId}/custom_subdomain`, "GET", {}, { signal });
  }
);
